import React, { useState, useEffect } from "react";
import ExchangeRates from "./ExcahngeRates";
import Table from "./Table";
import MainInfo from "./MainInfo";
import Welcome from "./Welcome";
import DougnoutChart from "./DougnoutChart";
import ShortInvestments from "./ShortInvestments";
import "./home.scss";
import {
  useGetMainQuery,
  useGetSingleClientTransactionsQuery,
} from "services/clientApi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const HomeComp = () => {
  const { data: main, isLoading: loading, isError: error, refetch } = useGetMainQuery();
  const { data: transactions, isLoading: loadingTransactions } = useGetSingleClientTransactionsQuery(main?.user?.id);
  const screenWidth = useSelector((state) => state?.common?.screenWidth);
  const [isMobile, setIsMobile] = useState("");
  const navigate = useNavigate();
  let firstLoadRef = true;

  const logOut = () => {
    localStorage.removeItem("isClient");
    localStorage.removeItem("auth_client");
    navigate("/login");
    window.location.reload();
  };

  if (error) {
    logOut()
  }

  useEffect(() => {
    if (
      screenWidth === "lg" ||
      screenWidth === "md" ||
      screenWidth === "sm" ||
      screenWidth === "xs"
    ) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [screenWidth]);

  const firstLoad = () => {
    if (firstLoadRef) {
      const timer = setTimeout(() => {
        refetch();
      }, 2300);
      firstLoadRef = false;

      return () => clearTimeout(timer);
    }
  }

  useEffect(() => {
    firstLoad();
    refetch();
    const interval = setInterval(() => {
      refetch();
    }, 60000);

    return () => clearInterval(interval);
  }, [refetch]);

  const SkeletonLoader = ({ type }) => {
    switch (type) {
      case 'welcome':
        return <div className="skeleton-welcome"></div>;
      case 'mainInfo':
        return <div className="skeleton-main-info"></div>;
      case 'table':
        return <div className="skeleton-table"></div>;
      case 'doughnutChart':
        return <div className="skeleton-doughnut-chart"></div>;
      case 'shortInvestments':
        return <div className="skeleton-short-investments"></div>;
      default:
        return null;
    }
  };

  return (
    <div className="w-100 home-wrapper">
      {loading || loadingTransactions ? (
        <div>
          <div>
            <div className="w-95 m-auto">
              <SkeletonLoader type="welcome" />
            </div>
            <div className="d-flex justify-content-between">
              <div className="w-100 m-auto">
                <div className={`${isMobile ? "w-95 m-auto" : "d-flex justify-content-between gap-5 w-95 m-auto mt-4"}`}>
                  <div className={`${isMobile ? "w-95 m-auto mt-4" : "w-100 d-flex gap-5 m-auto"}`}>
                    <SkeletonLoader type="table" />
                    <SkeletonLoader type="doughnutChart" />
                  </div>
                </div>
                <div className={`${isMobile ? "w-95 m-auto" : "d-flex justify-content-between gap-5 w-95 m-auto mt-4"}`}>
                  <div className={`${isMobile ? "w-95 m-auto mt-4" : "w-100 d-flex gap-5 m-auto"}`}>
                    <SkeletonLoader type="table" />
                    <SkeletonLoader type="doughnutChart" />
                    <SkeletonLoader type="doughnutChart" />
                  </div>
                </div>
                <div className={`${isMobile ? "w-95 m-auto" : "d-flex justify-content-between gap-5 w-95 m-auto mt-4"}`}>
                  <div className={`${isMobile ? "w-95 m-auto mt-4" : "w-100 d-flex gap-5 m-auto"}`}>
                    <SkeletonLoader type="shortInvestments" />
                  </div>
                </div>
                <div className={`${isMobile ? "w-95 m-auto" : "d-flex justify-content-between gap-5 w-95 m-auto mt-4"}`}>
                  <div className={`${isMobile ? "w-95 m-auto mt-4" : "w-100 d-flex gap-5 m-auto"}`}>
                    <SkeletonLoader type="shortInvestments" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <Welcome main={main} />
          <div className="d-flex justify-content-between">
            <div className="w-100 m-auto">
              <div>
                <div className="text-end mx-5"></div>
                <MainInfo main={main} />
              </div>
              <div className={`${isMobile ? "w-95 m-auto" : "d-flex justify-content-between gap-5 w-95 m-auto mt-4"}`}>
                <div className={`${isMobile ? "w-95 m-auto mt-4" : "w-70 d-flex gap-5 m-auto"}`}>
                  <Table loading={loadingTransactions} transactions={transactions} />
                  <div className={`${isMobile ? "w-100 m-auto mt-5" : "w-100"}`}>
                    <DougnoutChart main={main} />
                  </div>
                </div>
                <div className={`${isMobile ? "w-95 m-auto my-4" : "w-50"}`}>
                  <ShortInvestments />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeComp;
